import React from 'react'
import './NachStop.css'

const NachPopup = ({handleNachStopYesBtn, setIsNachPopUpShow, disableYesBtn }) => {
    return (
        <>
            <div id="popup" className="popup">
                <div className="popup-content">
                    <div id="closePopupBtn" className="close-btn" onClick={()=>setIsNachPopUpShow(false)}>&times;</div>
                    <div>Do you want to stop NACH?</div>
                    <div className="comment-btn cp">
                        <span className="me-2" style={{cursor: disableYesBtn ? "not-allowed" : "pointer",backgroundColor:disableYesBtn ? 'lightgray' : '#f29766'}} onClick={() => !disableYesBtn && handleNachStopYesBtn()} >Yes</span>
                        <span className="ms-2" onClick={()=>setIsNachPopUpShow(false)}>No</span>
                    </div>
                </div>
            </div>
        </>
    )
}

export default NachPopup
